{
  "background": {
    "default": {
      "$type": "color",
      "$description": "Page canvas — the base background behind all content.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.0196078431372549,
          0.027450980392156862,
          0.03529411764705882
        ],
        "alpha": 1,
        "hex": "#050709"
      }
    },
    "subtle": {
      "$type": "color",
      "$description": "Subtly differentiated background for alternating or grouped sections.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.054901960784313725,
          0.06666666666666667,
          0.07450980392156863
        ],
        "alpha": 1,
        "hex": "#0e1113"
      }
    }
  },
  "surface": {
    "default": {
      "$type": "color",
      "$description": "Default container surface — cards, panels, and inputs on the page.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.054901960784313725,
          0.06666666666666667,
          0.07450980392156863
        ],
        "alpha": 1,
        "hex": "#0e1113"
      }
    },
    "raised": {
      "$type": "color",
      "$description": "Raised surface for higher-elevation layers (menus, popovers, dialogs). Higher elevation reads lighter in dark mode.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.13333333333333333,
          0.15294117647058825,
          0.16862745098039217
        ],
        "alpha": 1,
        "hex": "#22272b"
      }
    },
    "sunken": {
      "$type": "color",
      "$description": "Recessed surface for wells and inset regions.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.0196078431372549,
          0.027450980392156862,
          0.03529411764705882
        ],
        "alpha": 1,
        "hex": "#050709"
      }
    }
  },
  "text": {
    "default": {
      "$type": "color",
      "$description": "Primary body and heading text.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9607843137254902,
          0.9607843137254902,
          0.9607843137254902
        ],
        "alpha": 1,
        "hex": "#f5f5f5"
      }
    },
    "muted": {
      "$type": "color",
      "$description": "Secondary text — supporting copy, captions, metadata.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.803921568627451,
          0.8274509803921568,
          0.8392156862745098
        ],
        "alpha": 1,
        "hex": "#cdd3d6"
      }
    },
    "subtle": {
      "$type": "color",
      "$description": "Tertiary text — placeholders and disabled labels. The mid-grey reads in both modes.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5333333333333333,
          0.5607843137254902,
          0.5725490196078431
        ],
        "alpha": 1,
        "hex": "#888f92"
      }
    },
    "inverse": {
      "$type": "color",
      "$description": "Text and icons rendered on an action or solid fill.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.0196078431372549,
          0.027450980392156862,
          0.03529411764705882
        ],
        "alpha": 1,
        "hex": "#050709"
      }
    },
    "link": {
      "$type": "color",
      "$description": "Inline hyperlink text.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5490196078431373,
          0.8784313725490196,
          1
        ],
        "alpha": 1,
        "hex": "#8ce0ff"
      }
    }
  },
  "border": {
    "default": {
      "$type": "color",
      "$description": "Default border for inputs, cards, and dividers.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.20784313725490197,
          0.23137254901960785,
          0.24705882352941178
        ],
        "alpha": 1,
        "hex": "#353b3f"
      }
    },
    "subtle": {
      "$type": "color",
      "$description": "Low-emphasis border for subtle separation.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.13333333333333333,
          0.15294117647058825,
          0.16862745098039217
        ],
        "alpha": 1,
        "hex": "#22272b"
      }
    },
    "strong": {
      "$type": "color",
      "$description": "High-emphasis border for focus and selected states.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5333333333333333,
          0.5607843137254902,
          0.5725490196078431
        ],
        "alpha": 1,
        "hex": "#888f92"
      }
    }
  },
  "action": {
    "default": {
      "$type": "color",
      "$description": "Primary interactive colour — buttons, links, key accents. NSW navy in light, brightened for contrast in dark.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.14901960784313725,
          0.6823529411764706,
          1
        ],
        "alpha": 1,
        "hex": "#26aeff"
      }
    },
    "hover": {
      "$type": "color",
      "$description": "Hover and active state for primary actions.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5490196078431373,
          0.8784313725490196,
          1
        ],
        "alpha": 1,
        "hex": "#8ce0ff"
      }
    },
    "subtle": {
      "$type": "color",
      "$description": "Tinted background for low-emphasis (ghost) actions.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.06274509803921569,
          0.21568627450980393
        ],
        "alpha": 1,
        "hex": "#001037"
      }
    }
  },
  "success": {
    "surface": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — tinted background.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.08627450980392157,
          0
        ],
        "alpha": 1,
        "hex": "#001600"
      }
    },
    "text": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — readable text on the tint.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5607843137254902,
          0.7803921568627451,
          0.5411764705882353
        ],
        "alpha": 1,
        "hex": "#8fc78a"
      }
    },
    "border": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — border and divider.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.35294117647058826,
          0.00784313725490196
        ],
        "alpha": 1,
        "hex": "#005a02"
      }
    },
    "solid": {
      "$type": "color",
      "$description": "Success (positive outcomes and confirmations) — solid fill for badges and icons.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.2235294117647059,
          0.6,
          0.21176470588235294
        ],
        "alpha": 1,
        "hex": "#399936"
      }
    }
  },
  "warning": {
    "surface": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — tinted background.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.15294117647058825,
          0.01568627450980392,
          0
        ],
        "alpha": 1,
        "hex": "#270400"
      }
    },
    "text": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — readable text on the tint.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9333333333333333,
          0.6588235294117647,
          0.5411764705882353
        ],
        "alpha": 1,
        "hex": "#eea88a"
      }
    },
    "border": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — border and divider.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5333333333333333,
          0.1843137254901961,
          0.011764705882352941
        ],
        "alpha": 1,
        "hex": "#882f03"
      }
    },
    "solid": {
      "$type": "color",
      "$description": "Warning (caution and pending states) — solid fill for badges and icons.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.8274509803921568,
          0.403921568627451,
          0.20392156862745098
        ],
        "alpha": 1,
        "hex": "#d36734"
      }
    }
  },
  "danger": {
    "surface": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — tinted background.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.13725490196078433,
          0,
          0.00784313725490196
        ],
        "alpha": 1,
        "hex": "#230002"
      }
    },
    "text": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — readable text on the tint.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9176470588235294,
          0.5725490196078431,
          0.5803921568627451
        ],
        "alpha": 1,
        "hex": "#ea9294"
      }
    },
    "border": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — border and divider.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.48627450980392156,
          0.023529411764705882,
          0.12156862745098039
        ],
        "alpha": 1,
        "hex": "#7c061f"
      }
    },
    "solid": {
      "$type": "color",
      "$description": "Danger (errors and destructive actions) — solid fill for badges and icons.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.7764705882352941,
          0.24705882352941178,
          0.3058823529411765
        ],
        "alpha": 1,
        "hex": "#c63f4e"
      }
    }
  },
  "info": {
    "surface": {
      "$type": "color",
      "$description": "Info (neutral information) — tinted background.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.00784313725490196,
          0.027450980392156862,
          0.10980392156862745
        ],
        "alpha": 1,
        "hex": "#02071c"
      }
    },
    "text": {
      "$type": "color",
      "$description": "Info (neutral information) — readable text on the tint.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5019607843137255,
          0.596078431372549,
          0.7607843137254902
        ],
        "alpha": 1,
        "hex": "#8098c2"
      }
    },
    "border": {
      "$type": "color",
      "$description": "Info (neutral information) — border and divider.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.09803921568627451,
          0.2,
          0.4
        ],
        "alpha": 1,
        "hex": "#193366"
      }
    },
    "solid": {
      "$type": "color",
      "$description": "Info (neutral information) — solid fill for badges and icons.",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.25882352941176473,
          0.39215686274509803,
          0.6431372549019608
        ],
        "alpha": 1,
        "hex": "#4264a4"
      }
    }
  }
}
